import React, { useState, useCallback } from "react";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Button, CheckboxCustom, Img, Text } from "components";
import Footer from "components/Footer";
import { useTranslation } from "react-i18next";
import ProductCartCardBox from "components/ProductCartCardBox";
import Breadcrumb from "components/Breadcrumb";
import globalRequest from "../../utils/global/globalRequest";
import { useDispatch, useSelector } from "react-redux";
import { changeLoader } from "../../redux/reducers/loader";
import * as CUSTOM from "../../utils/helper/custom";
import * as APIS from "../../utils/helper/Enum";
import EmptyListOrder from "../ProfilePage/AllTabsOption/EmptyListOrder";
import { useEffect } from "react";
import { currentTrigger } from "redux/reducers/trigger";
import { useLocation, useNavigate } from "react-router-dom";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Line } from "components";
import { getAllCategories } from "../../redux/reducers/allCategories";
import { getAuth } from "../../redux/reducers/loginData";
import { useAppFont } from "../../utils/helper/useAppFont";
let timer = null;

const AllProductListPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const loaderStatus = useSelector(currentTrigger);
  const getAllCatData = useSelector(getAllCategories);
  const auth = useSelector(getAuth);
  const dispatch = useDispatch();
  const [FilterOpen, setFilterOpen] = React.useState(false);
  const [SortOpen, setSortOpen] = useState(false);
  const [apiLoadStatus, setApiLoadStatus] = useState(true);
  const [productList, setProductList] = useState([]);
  const [cartData, setCartData] = useState([]);
  let [offsetLimit, setOffsetLimit] = useState({ limit: 9, page: 1 });
  const [isLoadMore, setLoadMore] = useState(false);
  const [inputData, setInputData] = useState({
    subcat: [],
    price: [],
    order_by: "isRecommended",
    order_type: "desc",
    subcatid: 0,
    name: "",
    list: "",
  });
  const [priceFilter, setPriceFilter] = useState([])
  const [wishlistIds, setWishlistIds] = useState(new Set());
  const { interClass, headingClass } = useAppFont();

  const hamburgerOpen = useSelector((state) => state.ui.hamburgerOpen);
  const pageName =
    location.pathname === "/all-products" ? "Product list" : location.pathname;
  const isLoading = useState(false)[0];
  const handleFilter = () => {
    setFilterOpen(!FilterOpen);
  };

  /**
   * get price in array
   */
  const priceByArray = () => {
    let indexes = inputData?.price;
    const categorizedRanges = [];
    let ranges = priceFilter;
    indexes.forEach((index) => {
      let k = 0;
      for (const range of ranges) {
        if (index == k) {
          categorizedRanges.push(
            `${range.min}-${range.max == "+" ? 9989864564545 : range.max}`,
          );
          break;
        }
        k++;
      }
    });
    return categorizedRanges.join(",");
  };

  /**
   * get all products
   */
  const getAllProductList = useCallback(async (type = "new") => {
    try {
      dispatch(changeLoader(true));
      let params = {
        price: priceByArray(inputData?.price),
        orderType: inputData?.order_type,
        orderBy: inputData?.order_by,
        page: offsetLimit?.page,
        limit: offsetLimit?.limit,
      };
      let response = await globalRequest(
        APIS?.PRODUCTS?.All_PRODUCTS,
        "get",
        {},
        { params: params },
        true,
      );
      response = response?.data;
      if (response?.status === "SUCCESS") {
        setProductList((prevList) => [...prevList, ...response?.data?.data]);
        setLoadMore(
          response?.data?.data.length < offsetLimit?.limit ? false : true,
        );
      } else {
        if (offsetLimit?.page === 1) {
          setProductList([]);
        }
        setLoadMore(false);
      }
    } catch (e) {
      setProductList([]);
    }
    dispatch(changeLoader(false));
    setApiLoadStatus(false);
  }, [dispatch, inputData, offsetLimit]);

  useEffect(() => {
   getAllProductList();
  }, [offsetLimit.page,  getAllProductList]);

  /**
   * const load more api
   */
  const loadMoredata = () => {
    let pageCount = offsetLimit?.page + 1;
    offsetLimit.page = pageCount;
    setLoadMore(false);
    setOffsetLimit({ ...offsetLimit, page: pageCount });
    getAllProductList();
  };

  /**
   * Handle infinite scroll
   */
  const handleScroll = (e) => {
    const scrollHeight = e.target.documentElement.scrollHeight;
    const currentHeight =
      e.target.documentElement.scrollTop + window.innerHeight + 450;
    if (currentHeight + 1 >= scrollHeight) {
      let clickMore = document.getElementById("loadmoreItem");
      if (clickMore) {
        clickMore.click();
      }
    }
  };

  const returnActualprice = (actualPrice, sellingPrice) => {
    let result = "";
    if (!actualPrice || actualPrice == sellingPrice) {
      return result;
    }
    return actualPrice;
  };

const getPriceRangeAndCount = async () => {
  try {
    const res = await globalRequest(
      APIS?.PRODUCTS?.GET_PRODUCT_PRICE_COUNT,
      "get",
      {},
      {},
      true
    );
    if (res?.data?.data) {
      setPriceFilter(res.data.data);
    }
  } catch (error) {
    console.error("Error fetching price filter:", error);
  }
};

  const fetchWishlist = useCallback(async () => {
    if (!auth?.id) return;
    try {
      const res = await globalRequest(
        APIS?.WISHLIST?.GET_WISHLIST,
        "get",
        {},
        { params: { page: 1, limit: 500 } },
        true
      );
      const data = res?.data;
      if (data?.status === "SUCCESS") {
        const ids = new Set(
          (data?.data?.data || []).map((item) => item?.productId)
        );
        setWishlistIds(ids);
      }
    } catch (e) {
    }
  }, [auth?.id]);

  const handleWishlistToggle = async (productId) => {
    if (!auth?.id) {
      alert("Please login to proceed", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      return;
    }
    try {
      const res = await globalRequest(
        APIS?.WISHLIST?.ADD_TO_WISHLIST,
        "post",
        { productId },
        {},
        true
      );
      const data = res?.data;
      if (data?.status === "SUCCESS") {
        setWishlistIds((prev) => {
          const updated = new Set(prev);
          if (data?.data?.isWishlist) {
            updated.add(productId); 
          } else {
            updated.delete(productId);
          }
          return updated;
        });
      }
    } catch (e) {
      console.error("Wishlist toggle error:", e);
    }
  };

  /**
   * first time call list api
   */
  useEffect(() => {
    setApiLoadStatus(true);
    setProductList([]);
    offsetLimit.page = 1;
    setOffsetLimit({ ...offsetLimit, page: 1 });
    dispatch(changeLoader(true));
    clearTimeout(timer);
    getPriceRangeAndCount();
    loadMoredata()
    timer = setTimeout(() => {
      getAllProductList();
    }, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData]);

  useEffect(() => {
    setCartData(CUSTOM.getCartData());
  }, []);

  useEffect(() => {
    if (loaderStatus == "loadCartData") {
      setCartData(CUSTOM.getCartData());
    }
  }, [loaderStatus]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    CUSTOM.handleScrollDepth(pageName);
  }, []);

  useEffect(() => {
    fetchWishlist();
  }, [fetchWishlist]);

  const filterStyle = !FilterOpen
    ? "sm:hidden"
    : "flex bg-white-A700 p-[16px] rounded-lg top-full absolute w-full z-50 m-0 sm:items-start sm:justify-start shadow-lg h-[296px] overflow-y-auto";
  return (
    <>
       {FilterOpen && (
          <div className="fixed inset-0 z-[999] bg-[#FFFFFF] sm:block hidden">
            <div className="flex flex-col h-screen">
              <div className="flex items-center justify-between px-4 py-4 border-b bg-white">
                <Text className={`text-lg font-semibold text-[#1A1A1A] ${interClass}`}>
                  {t("allFilters")}
                </Text>
                <button
                  className="text-2xl text-[#1A1A1A]"
                  onClick={() => setFilterOpen(false)}
                >
                  ✕
                </button>
              </div>
              <Line />
              <div className="flex-1 overflow-y-auto px-4 py-4 pb-28">
                <div className="flex flex-col gap-2 mb-6">
                  <Text
                    className={`text-base text-[#757575] ${interClass} rtl:text-right`}
                    size="txtnunitoMedium16"
                  >
                    {t("cakesCategories")}
                  </Text>

                  <div className="flex flex-col gap-2">
                    {getAllCatData?.map((items, index) => (
                      <CheckboxCustom
                        key={`cat-${index}`}
                        value={items?.id}
                        checked={inputData?.subcat.includes(items?.id)}
                        label={CUSTOM.getdataByLangKey(
                          items?.categoryLocales,
                          "",
                          "name"
                        )}
                        className="text-black text-sm product-list-checkbox"
                        onChange={() => {
                          const id = items?.id;
                          setInputData(prev => {
                            const subcat = prev.subcat.includes(id)
                              ? prev.subcat.filter(x => x !== id)
                              : [...prev.subcat, id];
                            return { ...prev, subcat };
                          });
                        }}
                      />
                    ))}
                  </div>
                </div>
                <div className="flex flex-col gap-2 mb-6">
                  <Text
                    className={`text-base text-[#757575] ${interClass} rtl:text-right`}
                    size="txtnunitoMedium16"
                  >
                    {t("PriceUppercase")}
                  </Text>

                  <div className="flex flex-col gap-2">
                    {priceFilter?.map((priceItem, index) => {
                      const label =
                        priceItem?.max !== "+"
                          ? ` ${priceItem.min} -  ${priceItem.max}`
                          : ` ${priceItem.min} +`;

                      return (
                        <CheckboxCustom
                          key={`price-${index}`}
                          label={
                            <div className="flex items-center gap-2">
                              <img
                                src="/images/Groupsar.svg"
                                alt="price"
                                className="w-4 h-4 object-contain"
                              />
                              <span className="price-filter-label">
                                {label}
                              </span>
                            </div>
                          }
                          checked={inputData.price.includes(index)}
                          className="text-[#3E4147] text-sm product-list-checkbox"
                          onChange={() => {
                            setInputData(prev => {
                              const price = prev.price.includes(index)
                                ? prev.price.filter(i => i !== index)
                                : [...prev.price, index];
                              return { ...prev, price };
                            });
                          }}
                        />
                      );
                    })}
                  </div>
                </div>
              </div>
              <div className="sticky bottom-0 bg-white border-t px-4 py-4 flex gap-4">
                <button
                  className="w-full border border-gray-300 text-black rounded-full py-2 font-semibold"
                  onClick={() =>
                    setInputData(prev => ({ ...prev, subcat: [], price: [] }))
                  }
                >
                  {t("clearAll")}
                </button>

                <button
                  className="w-full bg-[#761237] text-[#FFFFFF] rounded-full py-2 font-semibold"
                  onClick={() => setFilterOpen(false)}
                >
                  {t("applyFilter")}
                </button>
              </div>

            </div>
          </div>
        )}

       {SortOpen && (
        <div className="fixed inset-0 z-[998] top-[66%] h-[60vh] shadow-top shadow-md shadow-gray-300 rounded-t-2xl bg-white-A700 sm:block hidden">
          <div className="absolute  inset-0 " onClick={() => setSortOpen(false)} />
          <div className="fixed  left-0 right-0 bg-white rounded-t-2xl shadow-xl z-[1000] p-4">
            <div className="flex items-center justify-between">
              <Text className="text-lg font-semibold">{t("sort") || "Sort"}</Text>
              <button onClick={() => setSortOpen(false)} className="text-2xl">✕</button>
            </div>
            <Line className="bg-gray-300 h-px sm:h-[2px] w-full mt-3" />
            <div className="mt-3">
              {[
                "isRecommended",
                "high_to_low",
                "low_to_high",
                "isBestseller",
                "customerRaiting",
              ].map((val) => (
                <div key={val} className="flex items-center justify-between py-3 border-b last:border-b-0">
                  <label className="flex items-center gap-3 cursor-pointer" onClick={() => setInputData({...inputData, order_by: val, order_type: val.includes("low") ? "asc" : "desc"})}>
                    <input type="radio" name="mobileSort" checked={inputData.order_by === val} readOnly className="w-4 h-4" />
                    <span className="text-sm">
                      {val === "isRecommended" && t("recommended")}
                      {val === "high_to_low" && t("highToLow")}
                      {val === "low_to_high" && t("lowToHigh")}
                      {val === "isBestseller" && t("bestSeller")}
                      {val === "customerRaiting" && t("customerraiting")}
                    </span>
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
     {hamburgerOpen && (<div className={`fixed sm:block bottom-4 left-1/4  z-[997]  hidden`}>
        <div className="rounded-full bg-[#761237] border border-[#FFFFFF] px-3 py-2 shadow-md flex justify-between items-center">
          <button className="flex items-center gap-2 text-[#FFFFFF] px-4 py-2 rounded-full" onClick={() => setSortOpen(true)}>
            <Img src="/images/swap_vert.svg" className="w-4 h-4" alt="sort" />
            <span className="text-sm font-semibold"> {t("sort") || "Sort"}</span>
          </button>
          <div className="w-px h-6 bg-[#FFFFFF] mx-2"></div>
          <button className="flex items-center gap-2 text-[#FFFFFF] px-4 py-2 rounded-full" onClick={() => setFilterOpen(true)}>
            <Img src="/images/filterIcon.svg" className="w-4 h-4" alt="filter" />
            <span className="text-sm font-semibold"> {t("filter") || "Filter"}</span>
          </button>
        </div>
      </div>)}
        <div className="bg-[#FEFBFC] flex flex-col items-center justify-start w-full mx-auto">
          <div className="w-full ml-[20%]"><Breadcrumb  data={inputData} type="allProduct"/> </div>       
          <div className="flex flex-row xs:flex-wrap font-nunitosemibold md:gap-10 xs:gap-4 items-center xs:items-start justify-between max-w-[1110px] mt-[11px] mx-auto md:px-5 w-full">
            <div className="relative w-full inline-block">
              <Text
                className="text-2xl md:text-[22px] text-[#771237] sm:text-xl relative"
                size="txtnunitoSemiBold24"
              >
                <span
                  className={`
                    text-[44px]
                    leading-[56px]
                    ${headingClass}
                    font-semibold
                    text-center
                    text-[#771237]
                    sm:text-[28px]
                    relative
                    inline-block
                  `}
                >
                  All Cak
                  <span className="relative inline-block">
                    e
                    <Img
                      src="/images/tom.png"
                      alt="tom"
                      className="
                        absolute
                        top-[-17px]
                        left-1/2
                        -translate-x-1/2
                        w-[56px]
                        h-[56px]
                        aspect-square
                        z-[-1]
                        sm:w-[40px]
                        sm:h-[40px]
                      "
                    />
                  </span>
                  s
                </span>
              </Text>
            </div>
             <FormControl size="small"  sx={{
                display: { xs: "none", md: "block" },
              }}>
              <Select
                value={inputData?.order_by || "isRecommended"}
                displayEmpty
                IconComponent={KeyboardArrowDownIcon}
                onChange={(e) =>
                  setInputData({
                    ...inputData,
                    order_by: e.target.value,
                    order_type: "desc",
                  })
                }
                sx={{
                  height: 44,
                  px: 4,
                  minWidth: 220,
                  borderRadius: "999px",
                  backgroundColor: "#fff",
                  border: "1px solid #ECEDEF",
                  "& fieldset": {
                    border: "none",
                  },
                }}
                renderValue={(selected) => (
                  <span>
                    <span className={`text-[16px] leading-[20px] ${interClass} font-normal text-center text-[var(--Blacks-700,#3E4147)]`} style={{ color: "#6B7280", marginRight: 4 }}>
                      Sort By:
                    </span>
                    <span className={`text-[16px] leading-[24px] ${interClass} font-medium text-center text-[var(--Blacks-900,#1A1A1A)]`} style={{ fontWeight: 500 }}>
                      {selected === "isRecommended" && t("recommended")}
                      {selected === "high_to_low" && t("highToLow")}
                      {selected === "low_to_high" && t("lowToHigh")}
                      {selected === "isBestseller" && t("bestSeller")}
                      {selected === "customerRaiting" && t("customerraiting")}
                    </span>
                  </span>
                )}
              >
                <MenuItem value="isRecommended" className={` ${interClass}`}>{t("recommended")}</MenuItem>
                <MenuItem value="high_to_low" className={` ${interClass}`}>{t("highToLow")}</MenuItem>
                <MenuItem value="low_to_high" className={` ${interClass}`}>{t("lowToHigh")}</MenuItem>
                <MenuItem value="isBestseller" className={` ${interClass}`}>{t("bestSeller")}</MenuItem>
                <MenuItem value="customerRaiting" className={` ${interClass}`}>
                  {t("customerraiting")}
                </MenuItem>
              </Select>
            </FormControl>
          </div>
            <div className="flex sm:flex-col flex-row font-nunitoregular gap-[30px] items-start justify-start max-w-[1123px] mx-auto md:px-5 w-full">
            <div className="bg-[#FFFFFF] sm:h-auto sm:hidden relative w-[24%] border border-[#ECEDEF] shadow-md rounded-2xl p-6 my-8 sm:w-full">
              <div className="flex flex-col font-nunitomedium gap-[21px]  justify-center m-auto w-full">
                <Text
                  className={`text-lg ${interClass} text-[#1A1A1A] font-bold`}
                  onClick={handleFilter}
                >
                  {t("allFilters")}
                </Text>
                <div
                  className={`sm:hidden flex flex-col font-nunitomedium gap-[21px] justify-center m-auto w-full`}
                >
                  {getAllCatData.length != 0  ? (
                    <>
                      <div className="flex flex-col gap-2 justify-start ">
                        <div className="flex">
                          <Text
                            className={`text-base text-black-900 ${interClass} font-normal font-semibold`}
                          >
                            {t("cakesCategories")}
                          </Text>
                        </div>
                        <div className={`flex sm:hidden flex-col ${interClass} relative`}>
                          {getAllCatData?.map((items, index) => {
                            return (
                              <div
                                className="flex flex-row items-center justify-start"
                                key={`cat-index${index}`}
                              >
                                <CheckboxCustom
                                  value={items?.id}
                                  checked={inputData?.subcat.includes(
                                    items?.id
                                  )}
                                  label={CUSTOM.getdataByLangKey(
                                    items?.categoryLocales,
                                    "",
                                    "name"
                                  )}
                                  className="text-black_900 text-sm mr-0 text-left product-list-checkbox rtl:text-right"
                                  onChange={(e) => {
                                    let id = items?.id;
                                    setInputData((prevData) => {
                                      let newSubcat = [...prevData.subcat];
                                      const existingIndex = newSubcat.indexOf(id);

                                    if (existingIndex !== -1) {
                                      newSubcat.splice(existingIndex, 1);
                                    } else {
                                      newSubcat.push(id);
                                    }

                                    return { ...prevData, subcat: newSubcat };
                                    });
                                  }}
                                />
                              </div>
                            );
                          })}
                        </div>
                      </div>{" "}
                      <Line className="bg-gray-300 h-px sm:h-[2px] w-full" />
                    </>
                  ) : (
                    ""
                  )}

                  <div className="flex flex-col gap-2 justify-start w-full">
                    <Text
                      className={`text-base text-black-900 ${interClass} font-semibold`}
                    >
                      {t("PriceUppercase")}
                    </Text>
                    <div className={`flex flex-col ${interClass} relative`}>
                      {priceFilter?.map((priceItem, index) => {
                        let labels =
                          priceItem?.max != "+"
                            ? ` ${priceItem?.min} -  ${
                                priceItem?.max
                              } (${priceItem?.count})`
                            : ` ${priceItem?.min}+  (${priceItem?.count})`;
                        return (
                          <div
                            className="flex flex-row items-center justify-start"
                            key={`keyid-${index}-${Math.random()}`}
                          >
                            <CheckboxCustom
                              label={
                                <div className="flex items-center gap-2">
                                  <img
                                    src="/images/Groupsar.svg"
                                    alt="price"
                                    className="w-4 h-4 object-contain"
                                  />
                                  <span className="price-filter-label">
                                    {labels}
                                  </span>
                                </div>
                              }
                              className="text-black_900 text-sm mr-0 text-left product-list-checkbox rtl:text-right"
                              checked={inputData?.price.includes(index)}
                              onChange={(e) => {
                                let id = index;
                                setInputData((prevData) => {
                                  const existingIndex =
                                    prevData.price.indexOf(id);
                                  if (existingIndex !== -1) {
                                    const newprice = [...prevData.price];
                                    newprice.splice(existingIndex, 1);
                                    return { ...prevData, price: newprice };
                                  } else {
                                    const newprice = [...prevData.price, id];
                                    return { ...prevData, price: newprice };
                                  }
                                });
                              }}
                            />{" "}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className="sm:flex justify-center items-center mx-auto gap-2 hidden">
                   <button className="bg-[#761237] text-[#FFFFFF] font-['Poppins'] rounded-full py-2 px-2">
                      {t("applyFilter")}
                   </button>
                   <button className="bg-[#FFFFFF] border border-[#761237] text-black-900 font-['Poppins'] rounded-full py-2 px-2">
                      {t("clearAll")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex md:flex-1 flex-col font-nunitomedium gap-[30px] items-start justify-start w-full md:w-full">
              <div className="flex flex-row items-center justify-start w-fit">
                {inputData?.price?.map((priceItemF) => {
                  let priceItem = priceFilter[priceItemF];
                  let labels =
                    priceItem?.max != "+"
                      ? `${t("sar")} ${priceItem?.min} - ${t("sar")} ${
                          priceItem?.max
                        }`
                      : `${t("sar")} ${priceItem?.min} +`;
                  return (
                    <Button
                      key={`price-p${priceItemF}`}
                      className="cursor-pointer flex h-8 items-center justify-center min-w-[181px] pl-3 mr-2 pr-2 rtl:mr-0 rtl:ml-2 py-1.5 rounded bg-red-50_01"
                      rightIcon={
                        <Img
                          className="h-[18px] mt-px ml-2 rtl:ml-0 rtl:mr-2"
                          src="/images/img_close_gray_900_01.svg"
                          alt="close"
                          onClick={(e) => {
                            setInputData((prevData) => {
                              const existingIndex =
                                prevData.price.indexOf(priceItemF);
                              if (existingIndex !== -1) {
                                const newprice = [...prevData.price];
                                newprice.splice(existingIndex, 1);
                                return { ...prevData, price: newprice };
                              } else {
                                const newprice = [
                                  ...prevData.price,
                                  priceItemF,
                                ];
                                return { ...prevData, price: newprice };
                              }
                            });
                          }}
                        />
                      }
                    >
                      <Text
                        className="text-gray-900_01 text-left text-sm rtl:text-right"
                        size="txtnunitoMedium16"
                      >
                        {<>{labels}</>}
                      </Text>
                    </Button>
                  );
                })}
                {inputData?.price.length > 0 ? (
                  <Text
                    className="text-pink-800 text-xs ml-2 rtl:ml-0 rtl:mr-2 cursor-pointer whitespace-nowrap"
                    size="txtnunitoRegular12Pink800"
                    onClick={(e) => {
                      setInputData({ ...inputData, price: [] });
                    }}
                  >
                    {t("clearAllSmallBrackets")}
                  </Text>
                ) : null}
              </div>
              <div className="sm:gap-3 gap-4 grid xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-3 grid-cols-3 justify-center min-h-[auto] w-full">
                {productList?.map((pitems, pindex) => {
                  return (
                    <ProductCartCardBox
                      productId={pitems?.id}
                      className="bg-white-A700 flex flex-1 flex-col items-center justify-start p-[16px] rounded-lg w-full"
                      productimage={CUSTOM.getImage(
                        pitems?.productUoms?.[0]?.productUomImages?.[0]
                          ?.image || ""
                      )}
                      isRecommended={pitems?.isRecommended}
                      isBestSeller={pitems?.isBestseller}
                      productRatingBox={!!pitems?.averageRating}
                      productrating={`${
                        pitems?.averageRating ? pitems?.averageRating : 0
                      } | ${pitems?.ratingCount ? pitems?.ratingCount : 0}`}
                      productName={`${CUSTOM?.getdataByLangKey(
                        pitems?.productLocales,
                        "",
                        "name"
                      )} - ${pitems?.productUoms?.[0]?.name || ""}`}
                      discountedPrice={
                        <>
                          {pitems?.productUoms?.[0]?.sellingPrice || ""}
                        </>
                      }
                      originalPrice={
                        !pitems?.productUoms?.[0]?.actualPrice ||
                        pitems?.productUoms?.[0]?.sellingPrice ==
                          pitems?.productUoms?.[0]?.actualPrice
                          ? ""
                          : pitems?.productUoms?.[0]?.actualPrice
                      }
                      buttonAddToCart
                      slug={pitems?.slug}
                      uomData={pitems?.productUoms?.[0]}
                      cartData={cartData}
                      isWishlist={wishlistIds.has(pitems?.id)}
                      onWishlistToggle={handleWishlistToggle}
                    />
                  );
                })}
              </div>
              {isLoading ? (
                <div className="flex h-12 items-center justify-center mt-4 mb-10 rounded-[50%] w-full">
                  <Img
                    src="/images/Loaderanim.png"
                    className="animate-spin"
                    alt="loaderanim"
                  />
                </div>
              ) : null}
              {productList?.length == 0 && apiLoadStatus == false ? (
                <>
                  <EmptyListOrder paragraph={t("noProductFound")} />
                </>
              ) : null}
            </div>
          </div>
          <Footer className="flex font-nunitoregular items-center justify-center mt-[54px] md:px-5 w-full" />
        </div>

    </>
  );
};

export default AllProductListPage;